module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"linkText":"View solutions to close my pension gap"},"de":{"linkText":"Lösungen zum Schließen meiner Rentenlücke anzeigen"}}')
  delete Component.options._Ctor
}
